import { useNavigate } from '@tanstack/react-router';
import { useCollectionSafe } from '_/contexts/CollectionContext';
import { useOrganization } from '_/contexts/OrganizationContext';
import { useProject } from '_/contexts/ProjectContext';
import { useCallback } from 'react';

export const useCancelCallback = (isEditMode: boolean): ((e: React.MouseEvent) => void) => {
  const collectionContext = useCollectionSafe();
  const selectedCollectionSlug = collectionContext?.selectedCollectionSlug || null;
  const { selectedOrgSlug } = useOrganization();
  const { selectedProjectSlug } = useProject();
  const history = useNavigate();

  return useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      if (isEditMode && selectedCollectionSlug) {
        void history({
          to: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/collections/${selectedCollectionSlug}`,
        });
      } else {
        void history({ to: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/collections` });
      }
    },
    [history, isEditMode, selectedCollectionSlug, selectedOrgSlug, selectedProjectSlug],
  );
};
